import React, { useMemo } from "react";
import MirsTable from "components/general/table/Table";
//General
import { useViewport } from 'components/general/useViewPort'
import { findArray } from 'helpers/utils'
//Summary With Starting Blocks
import { TableColumnsSummary as ColumnSummary, TableColumnsSummarySM as ColumnSummarySM } from 'components/sports/ath/summary/Columns'
//Summary Without Starting Blocks
import { TableColumnsSummaryWithoutSB as ColumnSummaryWithoutSB, TableColumnsSummaryWithoutSBSM as ColumnSummaryWithoutSBSM } from 'components/sports/ath/summary/Columns'
//Summary Relay
import { TableColumnsSummaryRelay as ColumnSummaryRelay, TableColumnsSummaryRelaySM as ColumnSummaryRelaySM } from 'components/sports/ath/summary/Columns'
//Summary Field Contest
import { TableColumnsSummaryFC as ColumnSummaryFC, TableColumnsSummaryFCSM as ColumnSummaryFCSM } from 'components/sports/ath/summary/Columns'
//Helpers
import { CATEGORY, getIsEvent800m, getIsEventRelay } from 'components/sports/ath/helper/AthHelpers'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";



const getConfiguration = (data, rsc, breakPoint) => {

    const columnsAdded = data?.config?.extendedConfig ? data.config.extendedConfig.sort((a, b) => a.pos - b.pos) : []
    const type = findArray(data?.config?.extendedConfig, { code: ['CATEGORY'] }).value
    let showQualMark = data?.phaseResults[0]?.items?.some(item => item.qualificationMark);

    const isStartingLine = findArray(data?.config?.extendedConfig, { code: ['START_IN_LANES'] })?.value === 'Y' ? true : false
    const isEvent800 = getIsEvent800m(rsc);
    const isEventRelay = getIsEventRelay(rsc);


    let configuration = {
        caption: null,
        columns: [],
        hiddenColumns: showQualMark ? [] : ['QualMark'],
        sortBy: [],
        filters: {
            ei_type: ['NONE'],
            ei_code: ['NONE']
        },
        configs: {
            columnsAdded: columnsAdded,
            previousCurrent: false,
        }
    };
    configuration.sortBy = [{ id: 'Rank', desc: false }]

    switch (type) {
        case CATEGORY.RACE: //Races

            if (isStartingLine && !isEvent800 && !isEventRelay) { //Track events with starting blocks
                configuration.columns =
                    breakPoint === "sm" || breakPoint === "xs"
                        ? ColumnSummarySM()
                        : ColumnSummary()
            } else if (isEventRelay) {                          //Relay
                configuration.columns =
                    breakPoint === "sm" || breakPoint === "xs"
                        ? ColumnSummaryRelaySM()
                        : ColumnSummaryRelay()

            } else {                                            //Track events without starting blocks
                configuration.columns =
                    breakPoint === "sm" || breakPoint === "xs"
                        ? ColumnSummaryWithoutSBSM()
                        : ColumnSummaryWithoutSB()
            }
            break;
        case CATEGORY.VJUMPS:                                   //Field Contest
        case CATEGORY.HJUMPS:
        case CATEGORY.THROWS:
            configuration.columns =
                breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnSummaryFCSM()
                    : ColumnSummaryFC()
            break;
        default:
            configuration.columns = []

    }




    return configuration;
};


const AthSummary = ({ data }) => {
    const { breakPoint } = useViewport();
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const phaseResults = data?.phaseResults[0];
    const resultStatus = phaseResults?.results?.status?.code;
    const rsc = phaseResults?.results?.eventUnitCode;
    const configEvent = useMemo(() => getConfiguration(data, mirs_rsc, breakPoint), [resultStatus, mirs_rsc, breakPoint]);
    const items = data?.phaseResults[0]?.items

    const showTileRule = items?.some(item => item?.extendedResults?.some(item => item.er_code === 'RULE' || item.er_code === 'MS'));
    if (!showTileRule) configEvent.hiddenColumns.push('Rule')

    return (
        <>

            {phaseResults?.items
                ? (
                    <>
                        < MirsTable
                            //Dato to show by row
                            data={phaseResults.items}
                            //Columnas a visualizar 
                            columns={configEvent.columns}
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            //Columns to hidde 
                            hiddenColumns={configEvent.hiddenColumns}
                            //When show tble is sorted by 
                            initialSortBy={configEvent.sortBy}
                            id={`mirs-table-result-${rsc}`}
                        />

                    </>
                ) : (
                    ''
                )
            }
        </>
    );
};

export default AthSummary;